import { QB_OPERATOR_TYPES } from '../helpers/types.js';

/* eslint-disable complexity */

var conditionSql = function conditionSql(condition, value) {
  var EQUAL = QB_OPERATOR_TYPES.EQUAL,
      NOT_EQUAL = QB_OPERATOR_TYPES.NOT_EQUAL,
      GREATER_THAN = QB_OPERATOR_TYPES.GREATER_THAN,
      LESS_THAN = QB_OPERATOR_TYPES.LESS_THAN,
      CONTAINS = QB_OPERATOR_TYPES.CONTAINS,
      NOT_CONTAINS = QB_OPERATOR_TYPES.NOT_CONTAINS,
      BETWEEN = QB_OPERATOR_TYPES.BETWEEN,
      GREATER_THAN_OR_EQUAL = QB_OPERATOR_TYPES.GREATER_THAN_OR_EQUAL,
      LESS_THAN_OR_EQUAL = QB_OPERATOR_TYPES.LESS_THAN_OR_EQUAL,
      START_WITH = QB_OPERATOR_TYPES.START_WITH;
  if (condition === EQUAL) return " = '".concat(value, "'");
  if (condition === NOT_EQUAL) return " <> '".concat(value, "'");
  if (condition === GREATER_THAN) return " > ".concat(value);
  if (condition === LESS_THAN) return " < ".concat(value);
  if (condition === CONTAINS) return " LIKE '%".concat(value, "%'");
  if (condition === NOT_CONTAINS) return " NOT LIKE '%".concat(value, "%'");
  if (condition === BETWEEN) return " BETWEEN ".concat(value[0], " AND ").concat(value[1], " ");
  if (condition === GREATER_THAN_OR_EQUAL) return " >= ".concat(value);
  if (condition === LESS_THAN_OR_EQUAL) return " <= ".concat(value);
  if (condition === START_WITH) return " LIKE '".concat(value, "%'");
  return condition;
};

var renderFilterSQl = function renderFilterSQl(filter) {
  var _filter$element = filter.element,
      field = _filter$element.field,
      operator = _filter$element.operator,
      value = _filter$element.value;
  return "".concat(field, " ").concat(conditionSql(operator, value) || '');
};

var sqlFormat = function sqlFormat(_ref) {
  var main = _ref.main,
      mapGroups = _ref.mapGroups,
      items = _ref.items;

  var groupSql = function groupSql(item, idGroup) {
    if (idGroup === main) {
      var _groupCondition = mapGroups[idGroup].condition === true ? 'AND' : 'OR';

      return " ( ".concat(filterSql(item, _groupCondition), " ) "); // eslint-disable-line
    }

    var groupCondition = item.element.condition === true ? 'AND' : 'OR';
    return " ( ".concat(filterSql(item.children, groupCondition), " ) "); // eslint-disable-line
  };

  var filterSql = function filterSql(filters, groupCondition) {
    var filterGroup = filters.map(function (filter) {
      if (filter.element.type === 'filter') return " ".concat(renderFilterSQl(filter), " ");
      return " ".concat(groupSql(filter) || '', " ");
    });
    return filterGroup.join(groupCondition);
  };

  var sql = " FROM [TABLE_NAME] WHERE ".concat(groupSql(items, main) || '', " ");
  return sql;
};

export { sqlFormat };
//# sourceMappingURL=sqlFormat.js.map
